import ClassManagerFeature from './ClassManagerFeature';
import ClassesManage from './ClassesManage';

export default ClassesManage;
export { ClassesManage, ClassManagerFeature };
